import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@jira/software__devops-fedramp-utils/src/isDevopsFeatureDisabledInFedRamp.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import componentWithCondition from '@jira/platform__component-with-condition/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsOpsgenieRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsOpsgenieRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import LinkOpsgeniePage, {
	LazyLinkOpsgeniePage,
} from './ui/project-settings/link-opsgenie/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

export const projectSettingsOpsgenieRouteEntry: Route = createEntry(
	projectSettingsOpsgenieRoute,
	() => ({
		group: 'project-settings-software',

		// eslint-disable-next-line no-restricted-syntax
		component: componentWithCondition(
			isDevopsFeatureDisabledInFedRamp,
			ErrorPagesNotFound,
			LinkOpsgeniePage,
		),

		layout: softwareProjectLayoutNoOnboarding,
		resources: [...getSettingsNavigationResources()],

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		forPaint: [LazyAtlassianNavigation, LazyLinkOpsgeniePage],
		ufoName: 'project-settings.link-opsgenie',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
